import { metaKey } from '~/scripts/utils';

export default async ({ $api, route, store }) => {
  let productPath = null;

  if (route.path.includes('compare-tv-broadband-phone')) {
    productPath = 'broadband/bundles';
  } else if (['life-insurance', 'serious-illness', 'mortgage-protection', 'income-protection'].some(p => route.path.includes(p))) {
    const coverType = store.getters['products/getCoverType'];
    const replacedCoverTypeProduct = coverType.product.replace('-', '_');
    productPath = `protection/${replacedCoverTypeProduct}_plans`;
  } else {
    const category = metaKey(route, 'category');
    const product = metaKey(route, 'product');
    productPath = `${category}/${product}`.split('-').join('_'); // they look like little happy faces
  }
  const slug = route.params.provider;
  if (!slug) {
    store.commit('providers/clearCurrent');
  }
  await $api(productPath, { slug }).then(products => {
    store.commit('products/setList', products);
    store.commit('providers/setListFromProducts', products);

    if (route.path.includes('your-results')) {
      const searchID = store.getters['search/get'].id ? store.getters['search/get'].id : 'ID Not Found';
      store.dispatch('matomo/trackResultsReached', {name: `search ${searchID}`});
    }
  });
};
